import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // <--- Ye naya hook hai
import "./Popup.css"; 

const PopupForm = () => {
    const [showPopup, setShowPopup] = useState(false);
    const location = useLocation(); // Current page ka pata lagane ke liye
    
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: ""
    });
    const [status, setStatus] = useState({ loading: false, msg: "" });

    // Logic: Jab bhi location.pathname (URL) change hoga, ye chalega
    useEffect(() => {
        // Page change hote hi popup chupayen (reset)
        setShowPopup(false);

        // Naya timer shuru karein (5 seconds)
        const timer = setTimeout(() => {
             setShowPopup(true);
        }, 5000);

        // Agar user jaldi se doosre page pe chala jaye to timer rok dein
        return () => clearTimeout(timer);
        
    }, [location.pathname]); // <--- Ye dependency zaroori hai

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const closePopup = () => {
        setShowPopup(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ loading: true, msg: "" });

        const payload = {
            firstName: formData.name,
            email: formData.email,
            phone: formData.phone,
            subject: "POPUP OFFER: 50% OFF Request",
            message: "User wants to signup for 50% Discount Offer via Popup."
        };

        try {
            const response = await fetch("http://localhost:5000/send-email", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                setStatus({ loading: false, msg: "Success! Coupon sent." });
                setTimeout(() => closePopup(), 2000);
            } else {
                setStatus({ loading: false, msg: "Error submitting." });
            }
        } catch (error) {
            setStatus({ loading: false, msg: "Server Error." });
        }
    };

    if (!showPopup) return null;

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <button className="close-btn" onClick={closePopup}>&times;</button>
                
                <div className="popup-header">
                    <h3 className="popup-title">WAIT!</h3>
                    <span className="highlight">GET 50% OFF</span>
                    <p className="popup-desc">Don't leave empty handed. Grab your discount now.</p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <input type="text" name="name" placeholder="Name" required onChange={handleChange} />
                    </div>
                    <div className="input-group">
                        <input type="email" name="email" placeholder="Email Address" required onChange={handleChange} />
                    </div>
                    <div className="input-group">
                        <input type="text" name="phone" placeholder="Phone (Optional)" onChange={handleChange} />
                    </div>

                    <button type="submit" className="popup-btn" disabled={status.loading}>
                        {status.loading ? "Processing..." : "GET MY DISCOUNT"}
                    </button>

                    {status.msg && <p className="status-msg">{status.msg}</p>}
                </form>
            </div>
        </div>
    );
};

export default PopupForm;